import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  IconButton,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { FaWhatsapp, FaInstagram, FaTelegram, FaTiktok } from "react-icons/fa";
import { FiFacebook } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";

const countries = [
  { code: "LB", label: "Lebanon", flag: "🇱🇧", },
  { code: "IN", label: "India", flag: "🇮🇳" },
  { code: "US", label: "United States", flag: "🇺🇸" },
  { code: "GB", label: "United Kingdom", flag: "🇬🇧" },
  { code: "CA", label: "Canada", flag: "🇨🇦" },
  { code: "AU", label: "Australia", flag: "🇦🇺" },
  { code: "DE", label: "Germany", flag: "🇩🇪" },
  { code: "FR", label: "France", flag: "🇫🇷" },
  { code: "IT", label: "Italy", flag: "🇮🇹" },
  { code: "ES", label: "Spain", flag: "🇪🇸" },
  { code: "BR", label: "Brazil", flag: "🇧🇷" },
  { code: "ZA", label: "South Africa", flag: "🇿🇦" },
  { code: "CN", label: "China", flag: "🇨🇳" },
  { code: "JP", label: "Japan", flag: "🇯🇵" },
  { code: "KR", label: "South Korea", flag: "🇰🇷" },
  { code: "AE", label: "United Arab Emirates", flag: "🇦🇪" },
  { code: "SG", label: "Singapore", flag: "🇸🇬" },
  { code: "RU", label: "Russia", flag: "🇷🇺" },
  { code: "MX", label: "Mexico", flag: "🇲🇽" },
  { code: "AR", label: "Argentina", flag: "🇦🇷" },
  { code: "NL", label: "Netherlands", flag: "🇳🇱" },
];

const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),

  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone is required"),
  phone1: Yup.string().required("Country is required"),
  address: Yup.string().required("Address is required"),
  message: Yup.string().required("Description is required"),
});

const PartnerForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [show, setShow] = useState(false);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      phone1: "LB",
      address: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm, setStatus }) => {
      setSubmitted(true);
      try {
        const payload = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phone: values.phone,
          phone1: values.phone1,
          address: values.address,
          message: values.message,
        };

        // ✅ Send to Google Sheets
        await fetch(
          "https://script.google.com/macros/s/AKfycbzFJsgybhy2yzey1m0TXf23ybNYKH4f2L9JREMUWUemh3mh127q5uA5M5cv3Ib6l-qyjw/exec",
          {
            method: "POST",
            mode: "no-cors", // Google Scripts require no-cors for anonymous
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        // ✅ Optional: Also send to EmailJS or another backend here

        setShow(true);
        setSubmitted(false);

        resetForm();
        // setStatus("success");
      } catch (error) {
        setSubmitted(false);

        console.error("Error submitting form:", error);
        alert("Something went wrong. Please try again.");
        // setStatus("error");
        setShow(false);
      }
    },
    // onSubmit: (values, { resetForm }) => {
    //   console.log("Form submitted", values);
    //   setSubmitted(true);
    //   resetForm();
    //   setTimeout(() => setSubmitted(false), 3000);
    // },
  });

  return (
    <Box px={{ xs: 2, sm: 3, md: 6, lg: 11 }} py={10}>
      <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={6}>
        {/* Left Side */}
        <Box flex={1} textAlign={{ xs: "center", md: "left" }}>
          <Typography variant="h2" fontWeight="bold" gutterBottom>
            Partner with Us
          </Typography>
          <Typography
            color="text.secondary"
            mb={2}
            fontWeight="500"
            fontSize="22px"
          >
            Let’s grow together
            <br />
            <Typography component="span" color="#19ABE2" fontWeight="bold">
              globally!
            </Typography>
          </Typography>

          <Box
            display="flex"
            gap={1}
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <IconButton
              href="https://api.whatsapp.com/send?phone=96178709578"
              target="_blank"
            >
              <FaWhatsapp />
            </IconButton>
            <IconButton
              href="https://www.instagram.com/bbcorpfx/"
              target="_blank"
            >
              <FaInstagram />
            </IconButton>
            <IconButton
              href="https://www.facebook.com/people/BBCorp/100094393060215/"
              target="_blank"
            >
              <FiFacebook />
            </IconButton>
            <IconButton href="https://tiktok.com/@bbcorpfx" target="_blank">
              <FaTiktok />
            </IconButton>
            <IconButton href="https://x.com/BBcorpSAL" target="_blank">
              <FaXTwitter />
            </IconButton>
            <IconButton href="https://t.me/bbcorpltd" target="_blank">
              <FaTelegram />
            </IconButton>
          </Box>
        </Box>

        {/* Right Side Form */}
        <Box
          flex={2}
          component="form"
          onSubmit={formik.handleSubmit}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {/* Full Name & Email */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              fullWidth
              label="Full Name"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              error={formik.touched.firstName && Boolean(formik.errors.firstName)}
              helperText={formik.touched.firstName && formik.errors.firstName}
              InputLabelProps={{
                sx: {
                  color: "#667085",
                  fontSize: "16px",
                  fontWeight: "500",
                  "&.Mui-focused": {
                    color: "#667085",
                  },
                },
              }}
              InputProps={{
                sx: {
                  color: "blue",
                  "& .MuiInputBase-input": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)", // ✅ light grey with opacity
                    padding: "12px 14px", // optional for vertical alignment
                    borderRadius: "8px", // optional: match MUI style
                    fontWeight: 500,
                    fontSize: 16,
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes default left spacing
                },
              }}
            />
            <TextField
              fullWidth
              label="Last name"

              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
              InputLabelProps={{
                sx: {
                  color: "#667085",
                  fontSize: "16px",
                  fontWeight: "500",
                  "&.Mui-focused": {
                    color: "#667085",
                  },
                },
              }}
              InputProps={{
                sx: {
                  color: "blue",
                  "& .MuiInputBase-input": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)", // ✅ light grey with opacity
                    padding: "12px 14px", // optional for vertical alignment
                    borderRadius: "8px", // optional: match MUI style
                    fontWeight: 500,
                    fontSize: 16,
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes default left spacing
                },
              }}
            />

          </Box>

          {/* Phone & Country */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box flex={1}>
              <PhoneInput
                country={"lb"}
                value={formik.values.phone}
                onChange={(phone) => formik.setFieldValue("phone", phone)}
                inputStyle={{
                  width: "100%",
                  height: "48px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "8px",
                  //   border: "1px solid #ccc",
                }}
                buttonStyle={{
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  border: "none",
                  borderRadius: "8px 0 0 8px",
                }}
                containerStyle={{
                  width: "100%",
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                specialLabel="" // This removes the default label
              />
              {formik.touched.phone && formik.errors.phone && (
                <Typography variant="caption" color="error">
                  {formik.errors.phone}
                </Typography>
              )}
            </Box>

            <Box flex={1}>
              <Select
                fullWidth
                name="phone1"
                value={formik.values.phone1}
                onChange={formik.handleChange}
                displayEmpty
                style={{ fontWeight: "400", fontSize: "16px", fontFamily: "SF Pro Display", }}
              >
                {countries.map((c) => (
                  <MenuItem
                    style={{ fontSize: "15px", fontWeight: "500" }}
                    key={c.code}
                    value={c.code}
                  >
                    {c.flag} {c.label}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.phone1 && formik.errors.phone1 && (
                <Typography variant="caption" color="error">
                  {formik.errors.phone1}
                </Typography>
              )}
            </Box>
          </Box>

          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            InputLabelProps={{
              sx: {
                color: "#667085",
                fontSize: "16px",
                fontWeight: "500",
                "&.Mui-focused": {
                  color: "#667085",
                },
              },
            }}
            InputProps={{
              sx: {
                color: "blue",
                "& .MuiInputBase-input": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)", // ✅ light grey with opacity
                  padding: "12px 14px", // optional for vertical alignment
                  borderRadius: "8px", // optional: match MUI style
                  fontWeight: 500,
                  fontSize: 16,
                },
              },
            }}
            FormHelperTextProps={{
              sx: {
                marginLeft: 0, // ✅ removes default left spacing
              },
            }}
          />
          {/* Address */}
          <TextField
            fullWidth
            label="Address"
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            error={formik.touched.address && Boolean(formik.errors.address)}
            helperText={formik.touched.address && formik.errors.address}
            InputLabelProps={{
              sx: {
                color: "#667085",
                fontSize: "16px",
                fontWeight: "500",
                "&.Mui-focused": {
                  color: "#667085",
                },
              },
            }}
            InputProps={{
              sx: {
                color: "blue",
                "& .MuiInputBase-input": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)", // ✅ light grey with opacity
                  padding: "12px 14px", // optional for vertical alignment
                  borderRadius: "8px", // optional: match MUI style
                  fontWeight: 500,
                  fontSize: 16,
                },
              },
            }}
            FormHelperTextProps={{
              sx: {
                marginLeft: 0, // ✅ removes default left spacing
              },
            }}
          />


          {/* Description */}
          {/* <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        label="Tell us more about your interest..."
                        name="message"
                        value={formik.values.message}
                        onChange={formik.handleChange}
                        InputProps={{
                            sx: {
                                color: "blue",
                                "& .MuiInputBase-input": {
                                    backgroundColor: "rgba(255, 255, 255, 0.1)", // ✅ light grey with opacity
                                    padding: "12px 14px", // optional for vertical alignment
                                    borderRadius: "8px", // optional: match MUI style
                                    fontWeight: 500,
                                    fontSize: 16,
                                },
                            },
                        }}
                        error={formik.touched.message && Boolean(formik.errors.message)}
                        helperText={formik.touched.message && formik.errors.message}
                       
                    /> */}
          <TextField
            fullWidth
            multiline
            minRows={4}
            label="Description"
            name="message"
            value={formik.values.message}
            onChange={formik.handleChange}
            error={
              formik.touched.message && Boolean(formik.errors.message)
            }
            helperText={formik.touched.message && formik.errors.message}
            InputLabelProps={{
              sx: {
                color: "#667085",
                fontSize: "16px",
                fontWeight: "500",
                "&.Mui-focused": {
                  color: "#667085",
                },
              },
            }}
            InputProps={{
              sx: {
                color: "blue",
                "& .MuiInputBase-input": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)", // ✅ light grey with opacity
                  padding: "12px 14px", // optional for vertical alignment
                  borderRadius: "8px", // optional: match MUI style
                  fontWeight: 500,
                  fontSize: 16,
                },
              },
            }}
            FormHelperTextProps={{
              sx: {
                marginLeft: 0, // ✅ removes default left spacing
              },
            }}
          />

          {/* Submit */}
          {show && (
            <Grid item xs={12}>
              <Typography variant="body2" color="rgba(89, 175, 153, 1)" style={{ fontSize: '16px' }} fontWeight="500">
                Thank you we’ll get back to you soon.
              </Typography>
            </Grid>
          )}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {/* {submitted && (
              <Typography color="green" fontWeight="500">
                Thank you, we’ll get back to you soon.
              </Typography>
            )} */}
            <Button
              type="submit"
              sx={{
                background: "#19ABE2",
                color: "#fff",
                width: "160px",
                borderRadius: "8px",
                textTransform: "none",
              }}
            >
              {submitted ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PartnerForm;
